import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Col,
  DatePicker,
  InputNumber,
  Radio,
  Row,
  Select,
  Space,
  TimePicker,
  Tooltip,
} from "antd";
import { BROADCAST_TYPE } from "constants";
import dayjs from "dayjs";
import moment from "moment/moment";
import { DAYS_OF_WEEK, OPTIONS_REPEAT } from "utils";

import AppButton from "components/button";

import styles from "./styles.module.scss";
const CustomRepeatForm = props => {
  const {
    onCancel,
    onSubmit,
    setIsOpenCustom,
    loading,
    numberRepeat,
    setNumberRepeat,
    handleSetTimeRepeat,
    setSelectedRepeatType,
    selectedRepeatType,
    showErrorMessage,
    setEndDateType,
    endDateType,
    setAmountEndDate,
    setCustomEndDate,
    setCustomListWeek,
    setSelectedTimezone,
    selectedTimezone,
    listTimezone,
    setCustomDayMonth,
    setCustomDateYear,
    customDateYear,
    repeatType,
    showErrorMessageYear,
    showErrorMessageEndDate,
    setShowErrorMessageEndDate,
    timeRepeat,
    setShowErrorMessageYear,
    customEndDate,
    setTimeRepeat,
    // customer,
  } = props;

  const { t } = useTranslation();
  const [listDays, setListDays] = useState([]);
  const [listDates, setListDates] = useState([]);
  const [disabled, setDisabled] = useState({
    isOn: true,
    isAfter: true,
  });

  useEffect(() => {
    handleDaysOfWeekDefault();
    renderDateOfMonth();
  }, []);

  useEffect(() => {
    if (repeatType) {
      switch (repeatType) {
        case BROADCAST_TYPE.REPEAT_DAILY:
          setNumberRepeat(1);
          setSelectedRepeatType("DAY");
          setEndDateType("NONE");
          break;
        case BROADCAST_TYPE.REPEAT_WEEKLY:
          setNumberRepeat(1);
          setSelectedRepeatType("WEEK");
          handleDaysOfWeekDefault();
          break;
        case BROADCAST_TYPE.REPEAT_EVERY_WEEKDAY:
          setNumberRepeat(1);
          setSelectedRepeatType("WEEK");
          const newList = DAYS_OF_WEEK.map(d => {
            if (d.label !== "S") {
              d.isChoose = true;
            }
            return d;
          });
          setCustomListWeek(
            newList
              .map(item => {
                if (item.isChoose) {
                  return item.value;
                } else {
                  return undefined;
                }
              })
              .filter(item => item !== undefined)
          );
          setListDays(newList);
          break;
        case BROADCAST_TYPE.REPEAT_ANNUALY:
          setNumberRepeat(1);
          setSelectedRepeatType("YEAR");
          setCustomDateYear(moment(new Date()));
          break;
        case BROADCAST_TYPE.REPEAT_CUSTOM:
          setNumberRepeat(1);
          setSelectedRepeatType("DAY");
          setEndDateType("NONE");
          break;
      }
    }
  }, [repeatType]);

  const handleDaysOfWeekDefault = () => {
    const today = moment.utc().local().day();
    const newList = DAYS_OF_WEEK.map(day => {
      switch (today) {
        case 1:
          if (day.key == "mon") {
            day.isChoose = true;
          }
          break;
        case 2:
          if (day.key == "tue") {
            day.isChoose = true;
          }
          break;
        case 3:
          if (day.key == "wed") {
            day.isChoose = true;
          }
          break;
        case 4:
          if (day.key == "thu") {
            day.isChoose = true;
          }
          break;
        case 5:
          if (day.key == "fri") {
            day.isChoose = true;
          }
          break;
        case 6:
          if (day.key == "sat") {
            day.isChoose = true;
          }
          break;
        case 7:
          if (day.key == "sun") {
            day.isChoose = true;
          }
          break;
      }
      return day;
    });
    setCustomListWeek(
      newList
        .map(item => {
          if (item.isChoose) {
            return item.value;
          } else {
            return undefined;
          }
        })
        .filter(item => item !== undefined)
    );
    setListDays(newList);
  };

  useEffect(() => {
    switch (endDateType) {
      case "NONE":
        setDisabled({
          isOn: true,
          isAfter: true,
        });
        break;
      case "ON":
        setDisabled({
          isOn: false,
          isAfter: true,
        });
        break;
      case "AFTER":
        setDisabled({
          isOn: true,
          isAfter: false,
        });
        break;
    }
  }, [endDateType]);

  const onChangeStatus = e => {
    const newList = listDays.map(day => {
      if (day.key === e) {
        day.isChoose = !day.isChoose;
      }
      return day;
    });
    const isEmpty = newList.filter(day => day.isChoose).length === 0;
    if (isEmpty) {
      handleDaysOfWeekDefault();
    } else {
      setListDays(newList);
      setCustomListWeek(
        newList
          .map(item => {
            if (item.isChoose) {
              return item.value;
            } else {
              return undefined;
            }
          })
          .filter(item => item !== undefined)
      );
    }
  };

  const onChangeOptionsEnd = e => {
    setEndDateType(e.target.value);
    if (e.target.value !== "ON") {
      setShowErrorMessageEndDate("");
    }
  };
  const handleChangeValue = val => {
    setSelectedRepeatType(val);
  };

  const handleChangeNumber = num => {
    if (num === 1) {
      if (selectedRepeatType.includes("S")) {
        setSelectedRepeatType(selectedRepeatType.replace("S", ""));
      }
    } else {
      if (!selectedRepeatType.includes("S")) {
        setSelectedRepeatType(`${selectedRepeatType}S`);
      }
    }
    setNumberRepeat(num);
  };

  const renderDateOfMonth = () => {
    let arr = [];
    for (let i = 1; i <= 31; i++) {
      arr.push({
        label: i,
        value: i,
      });
    }
    setListDates(arr);
  };
  const handleSetCustomYear = date => {
    if (date && date.$d) {
      setCustomDateYear(date);
      setShowErrorMessageYear("");
    }
  };

  const handleSetCustomEndDate = date => {
    if (date && date.$d) {
      setCustomEndDate(date);
      setShowErrorMessageEndDate("");
    }
  };

  const handleGetTimeRepeatNow = () => {
    const minutues = moment().local().minutes();
    const hours = moment().local().hours();
    if (minutues > 0 && minutues <= 5) {
      setTimeRepeat(moment().local().minutes(5));
    } else if (minutues > 5 && minutues <= 10) {
      setTimeRepeat(moment().local().minutes(10));
    } else if (minutues > 10 && minutues <= 15) {
      setTimeRepeat(moment().local().minutes(15));
    } else if (minutues > 15 && minutues <= 20) {
      setTimeRepeat(moment().local().minutes(20));
    } else if (minutues > 20 && minutues <= 25) {
      setTimeRepeat(moment().local().minutes(25));
    } else if (minutues > 25 && minutues <= 30) {
      setTimeRepeat(moment().local().minutes(30));
    } else if (minutues > 30 && minutues <= 35) {
      setTimeRepeat(moment().local().minutes(35));
    } else if (minutues > 35 && minutues <= 40) {
      setTimeRepeat(moment().local().minutes(40));
    } else if (minutues > 40 && minutues <= 45) {
      setTimeRepeat(moment().local().minutes(45));
    } else if (minutues > 45 && minutues <= 50) {
      setTimeRepeat(moment().local().minutes(50));
    } else if (minutues > 50 && minutues <= 55) {
      setTimeRepeat(moment().local().minutes(55));
    } else if (minutues > 55 && minutues <= 59) {
      setTimeRepeat(
        moment()
          .local()
          .hours(hours + 1)
          .minutes(0)
      );
    }
  };

  const renderExtraFooter = () => (
    <div
      style={{ display: "flex", alignItems: "center" }}
      onClick={() => handleGetTimeRepeatNow()}
    >
      <a>{t("label.now")}</a>
    </div>
  );

  // const handleFormatDateLocale = () => {
  //   const browserLocale = navigator.language;
  //   let dateLocale;
  //   dateLocale = moment()
  //     .tz(customer?.timeZone ? customer?.timeZone : moment.tz.guess())
  //     .locale(browserLocale);
  //   return `${dateLocale.format("YYYY-MM-DD")}`;
  // };

  return (
    <>
      <Space
        align="start"
        style={{
          width: "100%",
          marginTop: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div>{t("label.repeatEvery")}</div>
        <div>
          <InputNumber
            min={1}
            defaultValue={1}
            max={selectedRepeatType}
            value={numberRepeat}
            onChange={handleChangeNumber}
            style={{ marginRight: 8 }}
          />
          <Select
            style={{ width: 100 }}
            options={
              numberRepeat === 1
                ? OPTIONS_REPEAT.filter(
                    option => !option.value.includes("S") && option
                  )
                : OPTIONS_REPEAT.filter(
                    option => option.value.includes("S") && option
                  )
            }
            placeholder={"Select"}
            value={selectedRepeatType}
            onChange={handleChangeValue}
          />
        </div>
      </Space>
      {selectedRepeatType.includes("WEEK") && (
        <Space
          direction={"vertical"}
          align="start"
          style={{ width: "100%", marginTop: "10px" }}
        >
          <div>{t("label.repeatOn")}</div>
          <div style={{ display: "inline" }}>
            {listDays.map(day => {
              return (
                <Tooltip key={`${day.key}`} title={day.title}>
                  <Button
                    key={day.key}
                    value={day.key}
                    type={day.isChoose ? "primary" : "default"}
                    shape="circle"
                    style={{ marginLeft: day.key !== "sun" ? "10px" : "" }}
                    onClick={() => onChangeStatus(day.key)}
                  >
                    {day.label}
                  </Button>
                </Tooltip>
              );
            })}
          </div>
        </Space>
      )}
      {selectedRepeatType.includes("MONTH") && (
        <Space
          direction={"vertical"}
          align="start"
          style={{
            width: "100%",
            marginTop: "10px",
          }}
        >
          <div>{t("text.selectDayofMonth")}</div>
          <Select
            style={{ marginBottom: 8, width: "70px" }}
            options={listDates}
            defaultValue={1}
            onChange={setCustomDayMonth}
          />
        </Space>
      )}
      {selectedRepeatType.includes("YEAR") && (
        <Space
          direction={"vertical"}
          align="start"
          style={{
            width: "100%",
            marginTop: "10px",
          }}
        >
          <div>{t("text.selectDateRepeat")}</div>
          <DatePicker
            format={"YYYY-MM-DD"}
            onChange={handleSetCustomYear}
            value={customDateYear}
            showNow={true}
            changeOnBlur={true}
            disabledDate={currentDate => {
              if (moment(currentDate.$d).year() === moment(new Date()).year()) {
                if (
                  moment(currentDate.$d).month() < moment(new Date()).month()
                ) {
                  return true;
                } else if (
                  moment(currentDate.$d).month() ===
                    moment(new Date()).month() &&
                  moment(currentDate.$d).date() < moment(new Date()).date()
                ) {
                  return true;
                } else {
                  return false;
                }
              } else if (
                moment(currentDate.$d).year() > moment(new Date()).year()
              ) {
                return false;
              } else {
                return false;
              }
            }}
            style={{
              width: "100%",
              borderColor: showErrorMessageYear !== "" ? "red" : "",
            }}
          />
          {showErrorMessageYear && (
            <span style={{ color: "red" }}>{showErrorMessageYear}</span>
          )}
        </Space>
      )}
      <Space
        direction={"vertical"}
        align="start"
        style={{ width: "100%", marginTop: "10px" }}
      >
        <div>
          <div style={{ marginBottom: 8 }}>{t("label.timezone")}</div>
          <Select
            style={{ marginBottom: 8, width: "100%" }}
            defaultValue={selectedTimezone}
            options={listTimezone}
            onChange={setSelectedTimezone}
          />
        </div>
        <div style={{ display: "inline", width: "100%" }}>
          <div>{t("label.timeRepeat")}</div>
          <div style={{ width: "100%", marginTop: 8 }}>
            <TimePicker
              format={"HH:mm"}
              minuteStep={5}
              value={timeRepeat && dayjs(timeRepeat)}
              style={{
                width: "100%",
                borderColor: showErrorMessage !== "" ? "red" : "",
              }}
              showNow={false}
              onChange={handleSetTimeRepeat}
              renderExtraFooter={renderExtraFooter}
              popupClassName={styles.timePickerPopUp}
              onSelect={handleSetTimeRepeat}
              needConfirm={false}
              changeOnScroll={true}
            />
            {showErrorMessage && (
              <span style={{ color: "red" }}>{showErrorMessage}</span>
            )}
          </div>
        </div>
      </Space>
      <Space
        direction={"vertical"}
        align="start"
        style={{ width: "100%", marginTop: "10px", marginBottom: "30px" }}
      >
        <div>{t("label.ends")}</div>
        <Row gutter={16} style={{ width: "100%" }}>
          <Col span={12}>
            <Radio.Group onChange={onChangeOptionsEnd} defaultValue={"NONE"}>
              <Space direction="vertical">
                <Radio value={"NONE"}>{t("label.never")}</Radio>
                <Radio value={"ON"} style={{ marginTop: "20px" }}>
                  {t("label.on")}
                </Radio>
                <Radio value={"AFTER"} style={{ marginTop: "20px" }}>
                  {t("label.after")}
                </Radio>
              </Space>
            </Radio.Group>
          </Col>
          <Col span={12}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                width: "100%",
                height: "100%",
              }}
            >
              <DatePicker
                style={{
                  width: "100%",
                  marginBottom: "10px",
                  borderColor: showErrorMessageEndDate !== "" ? "red" : "",
                }}
                popupClassName={styles.datePickerPopUp}
                disabled={disabled.isOn}
                format={"YYYY-MM-DD"}
                onChange={handleSetCustomEndDate}
                value={customEndDate}
                showNow={true}
                needConfirm={false}
                changeOnScroll={true}
                disabledDate={currentDate => {
                  if (
                    moment(currentDate.$d).year() === moment(new Date()).year()
                  ) {
                    if (
                      moment(currentDate.$d).month() <
                      moment(new Date()).month()
                    ) {
                      return true;
                    } else if (
                      moment(currentDate.$d).month() ===
                        moment(new Date()).month() &&
                      moment(currentDate.$d).date() <= moment(new Date()).date()
                    ) {
                      return true;
                    } else {
                      return false;
                    }
                  } else if (
                    moment(currentDate.$d).year() > moment(new Date()).year()
                  ) {
                    return false;
                  } else {
                    return false;
                  }
                }}
              />
              {showErrorMessageEndDate && (
                <span style={{ color: "red" }}>{showErrorMessageEndDate}</span>
              )}
              <InputNumber
                addonAfter={"occurrences"}
                min={1}
                disabled={disabled.isAfter}
                onChange={setAmountEndDate}
              />
            </div>
          </Col>
        </Row>
      </Space>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          marginRight: "15px",
        }}
      >
        <AppButton
          label={t("button.cancel")}
          color={"grey"}
          loading={loading}
          type="button"
          onClick={() => {
            setIsOpenCustom(false);
            onCancel();
          }}
          size={"minimum"}
          className={"cancelButton"}
        />
        <AppButton
          label={t("button.send")}
          color={"blue"}
          loading={loading}
          type="submit"
          onClick={onSubmit}
          size={"minimum"}
        />
      </div>
    </>
  );
};

export default CustomRepeatForm;
